module.exports = __webpack_public_path__ + "img/yacht-4.d1da2a32.jpg";